import * as Sentry from '@sentry/react';

const SCRUBBED_HEADERS = ['authorization', 'cookie'];

export function scrubEvent(event) {
  const next = { ...event };
  delete next.user;
  if (next.request) {
    const { data, cookies, ...request } = next.request;
    if (request.headers) {
      request.headers = Object.fromEntries(
        Object.entries(request.headers).filter(([name]) => !SCRUBBED_HEADERS.includes(name.toLowerCase())),
      );
    }
    next.request = request;
  }
  return next;
}

// Inert unless REACT_APP_SENTRY_DSN is set, so local runs and tests send nothing.
export function initErrorTracking() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return false;
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE || undefined,
    sendDefaultPii: false,
    beforeSend: scrubEvent,
  });
  Sentry.setTag('region', (process.env.REACT_APP_REGION || 'UK').toUpperCase());
  return true;
}
